// extracted by mini-css-extract-plugin
export default {"thank":"LayoutThank_thank__9YRLd","active":"LayoutThank_active__BdAD0"};